import React, { Component } from 'react';
import { connect } from 'react-redux';
import './HomeLineProgram.css';
import * as api from '../../../../api';
import { PATH } from '../../../../constants';

class HomeLineProgram extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lineContent: [],
    };
  }

  // -------------------------------------------------------
  // Component
  // -------------------------------------------------------

  componentDidMount() {
    this.fetchData();
  }

  // -------------------------------------------------------
  // Tips
  // -------------------------------------------------------

  getTip(gridSize, tipData) {
    const timeData = tipData.times[tipData.tipTimeKey];
    const dateArray = timeData.date.split('-');
    return (
      <a
        key={tipData.key}
        className="tv-tip"
        href={`//www.ceskatelevize.cz/specialy/totostoleti/program-68#/detail/${tipData.key}/${tipData.tipTimeKey}`}
        target="_blank"
        style={{
          width: `${100 / gridSize}%`,
        }}
      >
        <div className="tip-in">
          <div className="time">{`${Number(dateArray[2])}. ${Number(dateArray[1])}. ${dateArray[0]} v ${timeData.time}`}</div>
          <div className="name-wrap">
            <div className="name">{tipData.title}</div>
            <img
              className="ico-play"
              src={`${PATH.IMG}ico/ico-program-video.png`}
              alt=""
            />
          </div>
          <div className="thumb">
            <img
              src={tipData.programme.image.replace(/https:|http:/g,'')}
              alt="Náhled"
            />
            <img
              src={`${PATH.IMG}homepage/frame-program-video.png`}
              alt=""
            />
          </div>
        </div>
      </a>
    );
  }

  // -------------------------------------------------------
  // Fetch
  // -------------------------------------------------------

  fetchData() {
    api.getHomeProgramLineData().then((data) => {
      this.setState({
        lineContent: data,
      });
    }).catch(() => {
      // todo - solve error state
    });
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const tips = [];
    if (this.state.lineContent.length > 0) {
      const gridSize = Math.min(
        Math.floor(this.props.width / 295),
        5,
      );
      // todo - move calculations out of render function
      let startDay = new Date().getDay();
      // parse sunday
      startDay = (startDay === 0) ? 6 : (startDay - 1);
      // parse length
      if (startDay + gridSize > this.state.lineContent.length) {
        startDay = this.state.lineContent.length - gridSize;
      }
      for (let i = 0; i < gridSize; i += 1) {
        tips.push(this.getTip(gridSize, this.state.lineContent[startDay + i]));
      }
    }

    return (
      <div id="program-tips-line">
        {tips.length > 0 &&
        <React.Fragment>
          <a
            className="title-main"
            href="//www.ceskatelevize.cz/specialy/totostoleti/program-68"
            target="_blank"
            rel="noopener noreferrer"
          >
            TV Program 1968
          </a>
          <div className="tips-wrap">
            {tips}
          </div>
        </React.Fragment>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  width: state.resize.width,
});

export default connect(mapStateToProps)(HomeLineProgram);



// WEBPACK FOOTER //
// ./src/components/App/Home/HomeLineProgram/HomeLineProgram.js